import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { AdminDrawer } from './AdminDrawer';

export const AdminsBar = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', position: 'relative' }}>
      <CssBaseline />
      <AdminDrawer />
      <Box component="main" sx={{ flexGrow: 1, overflow: 'auto' }}>
        {children}
      </Box>
    </Box>
  );
};
